import { Dispatcher } from 'flux'

import type { ComposerDispatchPayload } from './types'

type CustomDispatcher = Dispatcher<ComposerDispatchPayload> & {
  handleApiAction: typeof Dispatcher.prototype.dispatch
  handleViewAction: typeof Dispatcher.prototype.dispatch
  handlePusherAction: typeof Dispatcher.prototype.dispatch
  whenIdle: () => Promise<void>
}

let queuedDispatches = 0
const idleResolvers = new Set<() => void>()

const whenIdle = async (): Promise<void> => {
  await Promise.resolve()
  if (queuedDispatches === 0) return

  await new Promise<void>((resolve) => idleResolvers.add(resolve))
  return whenIdle()
}

const createHandler = function (source: string): (args: unknown) => void {
  return function (this: Dispatcher<unknown>, action: unknown): void {
    const dispatchOptions = {
      source,
      action,
    }

    // If the dispatcher is currently dispatching
    // then add the next dispatch into the event queue
    if (this.isDispatching()) {
      queuedDispatches += 1
      setTimeout(() => {
        try {
          this.dispatch(dispatchOptions)
        } finally {
          queuedDispatches -= 1
          if (queuedDispatches === 0) {
            idleResolvers.forEach((resolve) => resolve())
            idleResolvers.clear()
          }
        }
      }, 0)
    } else {
      this.dispatch(dispatchOptions)
    }
  }
}

const appDispatcher: CustomDispatcher = Object.assign(
  new Dispatcher<ComposerDispatchPayload>(),
  {
    handleApiAction: createHandler('API_ACTION'),
    handlePusherAction: createHandler('PUSHER_ACTION'),
    handleViewAction: createHandler('VIEW_ACTION'),
    whenIdle,
  },
)

export default appDispatcher
